import { useRouter } from 'next/router';

/**
 * Paths that enable full screen wizard view
 * These paths hide the navigation and show a streamlined wizard experience
 */
const WIZARD_VIEW_PATTERNS = [
  /^\/properties\/[^/]+\/listing$/,
  /^\/properties\/[^/]+\/create-listing$/,
  /^\/feature-launch-notification-banner-preview$/,
  /^\/id-verification$/,
];

/**
 * Hook to detect if current route should display in wizard view
 * Wizard view provides a full-screen, focused experience without navigation
 *
 * Used for:
 * - Property listing editing flow
 * - Create listing flow
 *
 * @returns true if current path matches wizard view patterns
 */
export const useIsWizardView = (): boolean => {
  const router = useRouter();
  const pathname = router.pathname;

  if (!pathname) return false;

  return WIZARD_VIEW_PATTERNS.some((pattern) => pattern.test(pathname));
};
